@if (helpOpen) {
	<div class="helpbox-container">
		<div class="helpbox-title" fxLayoutAlign="space-between center">
			<span>{{ 'common.help' | translate }}</span>
			<button mat-icon-button (click)="toggleHelp()"><mat-icon>close</mat-icon></button>
		</div>
		<div fxLayout="column" [innerHtml]="content()"></div>
	</div>
}
